import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {FulfillmentStepDisplayStatusGroupType} from "../../types/fulfillment-step-display-status-group.type";

export class FulfillmentLineStepsProgressBarComponent implements IController {

  fulfillmentLineSteps: any;

  public statuses: string[];
  public items: any;
  public fulfillmentStepDisplayStatusGroupType: typeof FulfillmentStepDisplayStatusGroupType = FulfillmentStepDisplayStatusGroupType;

  $onInit() {
    this.statuses = [FulfillmentStepDisplayStatusGroupType.pending, FulfillmentStepDisplayStatusGroupType.assigned, FulfillmentStepDisplayStatusGroupType.pickupInProgress,
      FulfillmentStepDisplayStatusGroupType.destinationInProgress, FulfillmentStepDisplayStatusGroupType.onHold, FulfillmentStepDisplayStatusGroupType.canceled,
      FulfillmentStepDisplayStatusGroupType.completed];
    this._initFulfillmentLineStepsStatusesMap();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.fulfillmentLineSteps && !changes.fulfillmentLineSteps.isFirstChange()) {
      this._initFulfillmentLineStepsStatusesMap();
    }
  }

  private _initFulfillmentLineStepsStatusesMap() {

    const items = [];


    this.fulfillmentLineSteps.forEach(step => {
      step.statusGroups.forEach(status => {
        if (status === this.fulfillmentStepDisplayStatusGroupType.problem) {
          return;
        }
        const index = _.findIndex(items, (i: any) => {
          return status === i?.displayStatusGroup;
        });

        index > -1 ? items[index].count++ : items.push({
          displayStatusGroup: status,
          count: 1,
        })
      })
    })

    this.items = items.sort(
      (a, b) => this.statuses.indexOf(a.displayStatusGroup) - this.statuses.indexOf(b.displayStatusGroup)
    )

  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineStepsProgressBar', {
    bindings: {
      fulfillmentLineSteps: '<',
    },
    template: require('./fulfillment-line-steps-progress-bar.html').default,
    controller: FulfillmentLineStepsProgressBarComponent
  });
